/**
 * P-36b (D-196) — a "פנימי בלבד" employee is never put on a customer's work
 * (owner, team, participant, assignee, forward target). The lists of the forms
 * leave her out when the work belongs to a customer; the server refuses it too.
 */
export function withoutInternalOnlyOnCustomerWork<T extends { internal_only?: boolean }>(people: readonly T[], isCustomerWork: boolean): T[] {
  return isCustomerWork ? people.filter((p) => p.internal_only !== true) : [...people];
}
